import { render, staticRenderFns } from "./IconEntities.vue?vue&type=template&id=cef08e3a&"
import script from "./IconEntities.vue?vue&type=script&lang=ts&"
export * from "./IconEntities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports